module.exports = __webpack_public_path__ + "img/move.bbe00c47.svg";